export type Status = 'active' | 'resolved' | string;

interface StatusBadgeProps {
  status: Status;
  statusLabels?: Record<string, string>;
}

const statusStyles: Record<string, string> = {
  active: 'bg-meeting-50 text-meeting-700',
  resolved: 'bg-meeting-warm text-meeting-600',
};

export const StatusBadge = ({ status, statusLabels }: StatusBadgeProps) => {
  const styles = statusStyles[status] || 'bg-gray-100 text-gray-800';
  const label = statusLabels?.[status] || status.charAt(0).toUpperCase() + status.slice(1);

  return <span className={`text-xs px-2 py-1 rounded-full font-medium ${styles}`}>{label}</span>;
};
